import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import { useSelector } from "react-redux";
import arrowLeft from "../../asessts/Images/arrow_left.svg";

import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { formatRole, formatRoleFitness } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
function FitnessCenterDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [fitnessCenterDetails, setFitnessCenterDetails] = useState({});
  const pageSlice = useSelector((state) => state.pageSlice.pageSlice);
  const [selectedImage, setSelectedImage] = useState(null);

  const navigate = useNavigate();
  const { state } = useLocation();
  const activeTab = state?.activeTab;

  const fetchFitnessCenterDetails = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-fitnessCenter/${id}`
      );
      setFitnessCenterDetails(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching fitness center details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFitnessCenterDetails();
  }, [id]);

  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const handleStatusChange = async (status) => {
    if (status === "approved") {
      setIsApproving(true);
    } else {
      setIsRejecting(true);
    }

    try {
      const response = await client.put(
        `/admin/profile/change-status/${id}`,
        null,
        {
          params: { status },
        }
      );

      if (response.data.status) {
        toast.success(
          response.data.message || `Request ${status} successfully`
        );
        fetchFitnessCenterDetails();
        navigate(-1);
      } else {
        toast.error(response.data.message || `Failed to ${status} request`);
      }
    } catch (error) {
      console.error(`Error ${status} request:`, error);
      toast.error(`Failed to ${status} request`);
    } finally {
      if (status === "approved") {
        setIsApproving(false);
      } else {
        setIsRejecting(false);
      }
    }
  };

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() =>
                    navigate(-1, { state: { activeTab: activeTab } })
                  }
                />
                <span>Requests</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img
                          src={fitnessCenterDetails?.information?.image}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div className="">
                          <h2>
                            {fitnessCenterDetails?.user?.firstName}{" "}
                            {fitnessCenterDetails?.user?.lastName}
                          </h2>
                          <p>
                            <span>Request ID:</span>{" "}
                            {fitnessCenterDetails?.profileId}
                          </p>
                        </div>
                        {pageSlice === "request" && activeTab === "Pending" && (
                          <div className="reject-approve-btn">
                            <button
                              className="reject-btn"
                              onClick={() => handleStatusChange("rejected")}
                              disabled={isRejecting || isApproving}
                            >
                              {isRejecting ? "Processing..." : "Reject"}
                            </button>
                            <button
                              className="approve-btn"
                              onClick={() => handleStatusChange("approved")}
                              disabled={isApproving || isRejecting}
                            >
                              {isApproving ? "Processing..." : "Approve"}
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Henry"
                            value={formatRoleFitness(
                              fitnessCenterDetails?.facilityOrProfession || ""
                            )}
                            readOnly
                          />
                        </div>
                        <div class="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={formatRole(fitnessCenterDetails?.role)}
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              fitnessCenterDetails?.user?.phoneNumber?.number
                                ? `+${fitnessCenterDetails?.user?.phoneNumber?.dialCode} ${fitnessCenterDetails?.user?.phoneNumber?.number}`
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={fitnessCenterDetails?.user?.email}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={
                              fitnessCenterDetails?.information?.address?.add
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          {/* <label>Website</label>
                        <input
                          type="text"
                          placeholder="Website"
                          value={fitnessCenterDetails?.website}
                          readOnly
                        /> */}
                        </div>
                        <div className="input-field"></div>
                      </div>
                      <div className="input-group">
                        {fitnessCenterDetails?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                fitnessCenterDetails?.information
                                  ?.additionalText
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {fitnessCenterDetails?.facilities && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Facilities</label>
                            <textarea
                              placeholder="Facilities"
                              value={fitnessCenterDetails?.facilities?.join(
                                ", "
                              )}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {fitnessCenterDetails?.otherServices && (
                <div className="request-document">
                  <h3>Other Services</h3>
                  <div className="other-services-container">
                    {fitnessCenterDetails?.otherServices &&
                    fitnessCenterDetails.otherServices.length > 0 ? (
                      fitnessCenterDetails.otherServices.map(
                        (service, index) => (
                          <div className="service-card" key={index}>
                            <h4 className="service-name">
                              {service.name || "Service Name"}
                            </h4>
                            <p className="service-desc">
                              {service.information}
                            </p>
                          </div>
                        )
                      )
                    ) : (
                      <p style={{ color: "#888" }}>No services available</p>
                    )}
                  </div>
                </div>
              )}
              {fitnessCenterDetails?.subscripions && (
                <div className="request-document-other">
                  <h4>Subscriptions</h4>
                  <div className="other-services-container">
                    {fitnessCenterDetails?.subscripions &&
                    fitnessCenterDetails.subscripions.length > 0 ? (
                      fitnessCenterDetails.subscripions.map(
                        (subscripion, index) => (
                          <div className="service-card" key={index}>
                            <h4 className="service-name">
                              {subscripion.type || "Service type"}
                            </h4>
                            <p className="service-desc">
                              {subscripion.details || "subscripion.details"}
                            </p>
                            <div style={{ marginTop: "4px" }}>
                              Price: ₦{subscripion.price}
                            </div>
                          </div>
                        )
                      )
                    ) : (
                      <p style={{ color: "#888" }}>No subscriptions</p>
                    )}
                  </div>
                </div>
              )}
              {fitnessCenterDetails?.trainers && (
                <div className="request-document-other">
                  <h4>Trainers</h4>
                  <div className="other-services-container">
                    {fitnessCenterDetails?.trainers?.map((trainer, index) => (
                      <div className="service-card" key={index}>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#d58de8",
                            fontWeight: "500",
                          }}
                        >
                          {trainer.category}
                        </div>
                        <div
                          style={{
                            fontWeight: "600",
                            marginTop: "4px",
                            fontSize: "20.98px",
                          }}
                        >
                          {trainer.name}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {fitnessCenterDetails?.documents && (
                <div className="request-document">
                  <h3>Professional Documents</h3>
                  <div className="doc-main">
                    <div>
                      {fitnessCenterDetails?.documents?.certificate && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                fitnessCenterDetails?.documents?.certificate
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={fitnessCenterDetails?.documents?.certificate}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {fitnessCenterDetails?.documents &&
                              Object.keys(fitnessCenterDetails.documents)
                                .length > 0
                                ? Object.keys(fitnessCenterDetails.documents)[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {fitnessCenterDetails?.documents?.license !== "" ? (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                fitnessCenterDetails?.documents?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={fitnessCenterDetails?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {fitnessCenterDetails?.documents &&
                              Object.keys(fitnessCenterDetails.documents)
                                .length > 0
                                ? Object.keys(fitnessCenterDetails.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* <div className="request-document">
              <h3>Personal Documents</h3>
              <div className="doc-main">
                <div>
                  <div className="doc">
                    <div className="doc-file">
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={fitnessCenterDetails?.personalDocuments?.nimc}
                        alt=""
                      />
                    </div>
                    <div className="Document-name">
                      <span>
                        {fitnessCenterDetails?.personalDocuments &&
                        Object.keys(fitnessCenterDetails.personalDocuments)
                          .length > 0
                          ? Object.keys(
                              fitnessCenterDetails.personalDocuments
                            )[1]
                          : "No document available"}
                      </span>
                    </div>
                  </div>
                  {fitnessCenterDetails?.personalDocuments?.license !== "" ? (
                    <div className="doc">
                      <div className="doc-file">
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={fitnessCenterDetails?.personalDocuments?.license}
                          alt=""
                        />
                      </div>
                      <div className="Document-name">
                        <span>
                          {fitnessCenterDetails?.personalDocuments &&
                          Object.keys(fitnessCenterDetails.personalDocuments)
                            .length > 0
                            ? Object.keys(
                                fitnessCenterDetails.personalDocuments
                              )[0]
                            : "No document available"}
                        </span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div> */}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
}

export default FitnessCenterDetail;
